import { Validators } from '@angular/forms';

export const emailValidators = [Validators.required, Validators.email];

export const passwordValidators = [
  Validators.required,
  Validators.pattern(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/),
];
